import { api } from './api';
import type { Pathway } from '@/types/pathway';
import type { SlideConfig } from '@/types/vrf';

const BASE_URL = '/mobile/labo-vrf';

export type VrfPhoto = { id?: number; url: string };

export type VrfConfig = {
  formConfig: SlideConfig[];
  pathway: Pathway | null;
};

export type VrfResponse = {
  exists: boolean;
  data?: unknown;
  photos?: VrfPhoto[];
  pro_arrived_at?: string;
  pro_departed_at?: string;
  comment_pro_labo?: string;
};

export type VrfVisitInfo = {
  id: number;
  name: string | null;
  step: string | null;
  patient: Record<string, unknown> | null;
};

export const getVrfVisit = (slotId: string | number) => {
  return api.get<VrfVisitInfo>(`${BASE_URL}/slots/${slotId}/visit`);
};

export const getVrfConfig = (slotId: string) => {
  return api.get<VrfConfig>(`${BASE_URL}/slots/${slotId}/config`);
};

export const getVrfResponse = (visitId: number) => {
  return api.get<VrfResponse>(`${BASE_URL}/visits/${visitId}/response`);
};

export const deleteVrfPhoto = (visitId: number, photoId: number) => {
  return api.delete(`${BASE_URL}/visits/${visitId}/photos/${photoId}`);
};

// Une requête par photo (pas un tableau dans le submit) : un seul payload JSON
// avec plusieurs photos base64 dépassait vite la limite body-parser.
export const addVrfPhoto = (visitId: number, photo: string) => {
  return api.post<VrfPhoto>(`${BASE_URL}/visits/${visitId}/photos`, { photo });
};

export type SubmitVrfPayload = {
  pathway_id?: string | number;
  data: unknown;
  pro_arrived_at: string;
  pro_departed_at: string;
  comment_pro_labo: string;
};

export const submitVrf = (visitId: number, payload: SubmitVrfPayload) => {
  return api.post<void>(`${BASE_URL}/visits/${visitId}/submit`, payload);
};
